import { Input } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React from 'react'
import { View } from 'styles/reactnative'
import { RichTextCreateEditor, RichTextUpdateEditor } from '../../components'

const SettingTextarea = ({
	title,
	value,
	setValue,
	style,
	update = false,
}: any) => {
	return (
		<View
			style={{
				height: 45,
				width: '100%',
				borderBottom: '1px solid #ddd',
				padding: 3,
				...style,
			}}>
			{update ? (
				<RichTextUpdateEditor
					content={value}
					setContent={setValue}
					boxheight={style?.height - 10 || 400}
					boxwidth={style?.width || '100%'}
				/>
			) : (
				<RichTextCreateEditor
					content={value}
					setContent={setValue}
					boxheight={style?.height - 10 || 400}
					boxwidth={style?.width || '100%'}
				/>
			)}
		</View>
	)
}

export default SettingTextarea
